package com.trevorwiebe.timesheet.core.domain.dto

import com.trevorwiebe.timesheet.core.domain.model.Carrier
import kotlinx.serialization.Serializable

@Serializable
data class CarrierDto(
    val contactName: String = "",
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    val email: String = "",
    val notes: String = "",
    val active: Boolean = true,
    val deleted: Boolean = false,
    val order: Int = 0,
)

fun CarrierDto.toCarrier(id: String) = Carrier(
    id = id,
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    email = email,
    notes = notes,
    active = active,
    deleted = deleted,
    order = order,
)

fun Carrier.toCarrierDto() = CarrierDto(
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    email = email,
    notes = notes,
    active = active,
    deleted = deleted,
    order = order,
)
